import { ApiReturn, Dpc, Service, ServiceExtended } from "../../types";
import API from "./../index";
import {
  FETCH_DPC_OVERVIEW,
  FETCH_DPC_SERVICE_HISTORY,
  FETCH_SERVICE,
  UPDATE_SERVICE,
  FETCH_DPC_DATA,
  FETCH_DPC_MESSAGES,
  UPDATE_MESSAGE_STATUS,
} from "./dpc.endpoint";

export const fetchDPCOverview = (
  partnerId?: string
): Promise<ApiReturn<Dpc[]> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      FETCH_DPC_OVERVIEW.replace(":partnerId", partnerId!),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchDPCServiceHistory = (
  dpcId: string
): Promise<ApiReturn<Service[]> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      FETCH_DPC_SERVICE_HISTORY.replace(":dpcId", dpcId),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchService = (
  serviceId?: string
): Promise<ApiReturn<ServiceExtended> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      FETCH_SERVICE.replace(":serviceId", serviceId!),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const updateService = (
  data: unknown,
  serviceId?: string
): Promise<ApiReturn<unknown> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.post(
      UPDATE_SERVICE.replace(":serviceId", serviceId!),
      { data },
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchDpcData = (
  dpcId: string
): Promise<ApiReturn<any> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      FETCH_DPC_DATA.replace(":dpcId", dpcId),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchDpcMessages = (
  partnerId: string,
  dpcId: string
): Promise<ApiReturn<any> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      FETCH_DPC_MESSAGES.replace(":partnerId", partnerId).replace(":dpcId", dpcId),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const updateDpcMessageStatus = (
  partnerId: string,
  messageId: string,
  status: string
): Promise<ApiReturn<any> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.update(
      UPDATE_MESSAGE_STATUS.replace(":partnerId", partnerId).replace(":messageId", messageId),
      { status },
      (res: any) => {
        resolve(res);
      },
      (err: any) => {
        reject(err);
      }
    );
  });
};
